import PageProtectedLayout from '../../../../components/Page/PageProtectedLayout';
import ImmuneHealth from './ImmuneHealth';
import { useTranslation } from '../../../../language';



export default function ImmuneHealthWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_immune_health')}
      headlineFontWeight={500}
      >
      
    <ImmuneHealth />

   
      
    </PageProtectedLayout>

  );
}